"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var FormComponent = /** @class */ (function (_super) {
    __extends(FormComponent, _super);
    function FormComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = __assign(__assign({}, _this.props), { errors: _this.props.errors ? _this.props.errors : {} });
        _this.onBlurHandlers = {};
        _this.onBlurHandlersFields = {};
        _this.transformBlurHandlers = function (onBlurHandlers, state) { return onBlurHandlers; };
        _this.renderError = function (field) {
            if (_this.state.errors[field]) {
                return (React.createElement("div", { className: "c-forms__responses" },
                    React.createElement("div", { className: "c-forms__response--error" },
                        React.createElement("span", { className: "fal fa-info-circle" }),
                        "\u00A0",
                        _this.state.tForm[_this.state.errors[field]])));
            }
            return '';
        };
        _this.renderFormsError = function (field) {
            if (_this.state.errors[field]) {
                return (React.createElement("div", { className: "c-forms__responses" },
                    React.createElement("div", { className: "c-forms__response--error" },
                        React.createElement("span", { className: "fal fa-info-circle" }),
                        "\u00A0",
                        _this.state.tForm[_this.state.errors[field]])));
            }
            return '';
        };
        _this.getUnsafeHtml = function (message) {
            var attr = {
                dangerouslySetInnerHTML: { __html: message },
            };
            return attr;
        };
        _this.renderErrors = function () {
            if (_this.state.errors['global'] && _this.state.errors['global'].length) {
                return (React.createElement("div", { className: "c-forms__errors" },
                    React.createElement("div", __assign({}, _this.getUnsafeHtml(_this.state.errors['global']), { className: "c-forms__error" }))));
            }
        };
        return _this;
    }
    FormComponent.prototype.componentWillReceiveProps = function (newProps) {
        this.setState(function (state) { return (__assign(__assign({}, state), { ui: newProps.ui, errors: newProps.errors ? newProps.errors : {} })); });
        if (JSON.stringify(this.state.form) !== JSON.stringify(newProps.form)) {
            this.setState(function (state) { return (__assign(__assign({}, state), { form: newProps.form })); });
        }
    };
    FormComponent.prototype.onSubmitHandler = function () {
        var _this = this;
        return function (event) {
            event.preventDefault();
            _this.setState(function (state) { return (__assign(__assign({}, state), { errors: __assign(__assign({}, state.errors), { global: null }) })); });
            var blurHandlers = _this.transformBlurHandlers(_this.onBlurHandlers, _this.state);
            var errors = Array.from(Object.entries(blurHandlers))
                .map(function (_a) {
                var fieldName = _a[0], fn = _a[1];
                return fn({ currentTarget: { value: _this.state.form[fieldName] } });
            })
                .filter(function (it) { return it.length; })
                .concat(Array.from(Object.entries(_this.onBlurHandlersFields))
                .map(function (_a) {
                var fieldName = _a[0], fn = _a[1];
                return fn({});
            })
                .filter(function (it) { return it.length; }));
            console.log(errors);
            if (errors.length) {
                _this.props.onFormError ? _this.props.onFormError(_this.state.form, errors, event) : null;
                return false;
            }
            _this.props.onFormSubmit(_this.state.form, event);
            return false;
        };
    };
    FormComponent.prototype.setLastFormState = function () {
        if (this.props.setLastFormState) {
            this.props.setLastFormState(this.state.form, this.state.errors);
        }
    };
    FormComponent.prototype.onChangeHandler = function (field) {
        var _this = this;
        return function (event) {
            var newValue = event.currentTarget.value;
            if (event.currentTarget.type === 'checkbox') {
                newValue = event.currentTarget.checked;
            }
            _this.setState(function (state) {
                var _a;
                return (__assign(__assign({}, state), { form: __assign(__assign({}, state.form), (_a = {}, _a[field] = newValue, _a)) }));
            }, _this.setLastFormState);
        };
    };
    FormComponent.prototype.onBlurHandler = function (field, validator) {
        var _this = this;
        if (validator === void 0) { validator = []; }
        return function (event) {
            var errors = validator.map(function (it) { return it(event.currentTarget.value); })
                .map(function (it) { return it; })
                .filter(function (it) { return it; });
            _this.setState(function (state) {
                var _a;
                var a = (__assign(__assign({}, state), { errors: __assign(__assign({}, state.errors), (_a = {}, _a[field] = errors.length ? errors[0] : null, _a)) }));
                return a;
            }, _this.setLastFormState);
            return errors;
        };
    };
    FormComponent.prototype.onBlurHandlerFields = function (field, fields, validator) {
        var _this = this;
        if (validator === void 0) { validator = []; }
        return function (event) {
            var allFields = [field].concat(fields);
            var errors = validator.map(function (it) { return it(allFields.map(function (f) { return _this.state.form[f]; })); })
                .map(function (it) { return it; })
                .filter(function (it) { return it; });
            _this.setState(function (state) {
                var _a;
                var a = (__assign(__assign({}, state), { errors: __assign(__assign({}, state.errors), (_a = {}, _a[field] = errors.length ? errors[0] : null, _a)) }));
                return a;
            }, _this.setLastFormState);
            return errors;
        };
    };
    return FormComponent;
}(React.Component));
exports.default = FormComponent;
